// Single source of truth for the Neutrals x Normal event links, shared by the
// dock "Shop" icon and the news dispatch so they can never drift apart.
export const TICKETS_URL =
  'https://www.eventbrite.com/e/neutrals-x-normal-tickets-2001889673904?aff=oddtdtcreator';

export const VENUE_MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=Planet+Ant+Theatre%2C+2320+Caniff+St%2C+Hamtramck%2C+MI+48212';
